
import React, { useEffect } from 'react';
import MyTripCard from '@/components/trips/MyTripCard';
import { Trip } from '@/types/itinerary';

interface MyTripsListProps {
  trips: (Trip & { isJoined?: boolean })[];
  onTripDeleted?: () => void;
}

const MyTripsList: React.FC<MyTripsListProps> = ({ trips, onTripDeleted }) => {
  // Log for debugging
  useEffect(() => {
    console.log(`MyTripsList rendered with ${trips.length} trips`);
  }, [trips]);

  // Create a unique identifier for each trip by combining id and isJoined status
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {trips.map((trip) => (
        <MyTripCard 
          key={`${trip.id}-${trip.isJoined ? 'member' : 'owner'}`}
          trip={trip} 
          onDelete={() => {
            console.log(`Trip ${trip.id} deletion callback triggered from MyTripsList`);
            if (onTripDeleted) {
              onTripDeleted();
            }
          }}
        />
      ))}
    </div>
  );
};

export default MyTripsList;
